import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from './supabaseClient.js';

export default function HomePageV2() {
  const [visitCount, setVisitCount] = useState(null);
  const [creatureCount, setCreatureCount] = useState(0);
  const [weeklyCreatureCount, setWeeklyCreatureCount] = useState(0);
  const [characters, setCharacters] = useState([]);
  const [selectedCharacter, setSelectedCharacter] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      const { count } = await supabase.from('characters').select('*', { count: 'exact' });
      setCreatureCount(count);
      await supabase.rpc('increment_visit_counter');
      const { data: visitsData } = await supabase.from('visit_counter').select('*').eq('id', 1).maybeSingle();
      if (visitsData) setVisitCount(visitsData.count);
    };

    const fetchWeeklyCount = async () => {
      const today = new Date();
      const firstDayOfWeek = new Date(today);
      firstDayOfWeek.setDate(today.getDate() - today.getDay());
      firstDayOfWeek.setHours(0, 0, 0, 0);
      const { count } = await supabase.from('characters').select('*', { count: 'exact' }).gte('created_at', firstDayOfWeek.toISOString());
      setWeeklyCreatureCount(count);
    };

    const fetchCharacters = async () => {
      const { data } = await supabase.from('characters').select('id, name, image, vs_votes, universo, creador_url').order('vs_votes', { ascending: false }).limit(500);
      setCharacters(data);
    };

    fetchCounts();
    fetchWeeklyCount();
    fetchCharacters();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white font-sans">
      <header className="flex justify-between items-center px-6 py-4 bg-black sticky top-0 z-50">
        <div className="flex items-center gap-4">
          <img src="/logooficial.png" alt="NubbiLand Logo" className="h-14 rounded-lg" />
          <h1 className="text-2xl font-extrabold text-white">NUBBIVERSE</h1>
        </div>
        <nav className="flex items-center gap-8">
          <Link to="/creadores-v2" className="text-white font-bold hover:text-yellow-400">Creators</Link>
          <Link to="/our-team" className="text-white font-bold hover:text-yellow-400">Our Team</Link>
          <Link to="/universes-list" className="text-white font-bold hover:text-yellow-400">Nubbiverses</Link>
          <Link to="/nubbigrid" className="text-white font-bold hover:text-yellow-400">Grid</Link>
          <Link to="/intro-video" className="text-white font-bold hover:text-yellow-400">Intro Video</Link>
          <Link to="#" className="text-white font-bold hover:text-yellow-400">FAQ</Link>
          <button className="text-white text-2xl">🔍</button>
        </nav>
      </header>

      <div className="flex justify-center py-10 px-4">
        <img src="/dreamit-banner.png" alt="Dream it Banner" className="w-full max-w-[400px] rounded-xl shadow-2xl" />
      </div>

      <div className="flex justify-center py-4">
        <Link to="/discover-ultra">
          <button className="bg-red-500 text-white text-3xl font-extrabold py-6 px-16 rounded-3xl shadow-xl hover:scale-110 transition">
            🚀 DISCOVER NUBBIS
          </button>
        </Link>
      </div>

      <section className="flex flex-wrap justify-center gap-4 py-4">
        <Link to="/what-is-nubbi" className="px-6 py-3 bg-black text-yellow-300 rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🤔 What is Nubbi?</Link>
        <Link to="/nubbucks" className="px-6 py-3 bg-blue-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">💵 Discover Nubbix 💰 </Link>
        <Link to="/universes-list" className="px-6 py-3 bg-green-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🌎 Nubbiverses</Link>
      </section>

      <section className="flex flex-wrap justify-center gap-4 py-4">
        <Link to="/create-nubbi" className="px-6 py-3 bg-purple-400 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🧪 Create Your Nubbi</Link>
        <Link to="/meetthenewbbis" className="px-6 py-3 bg-yellow-300 text-black rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🌟 Meet the Newbbis</Link>
        <Link to="/creadores-v2" className="px-6 py-3 bg-green-400 text-black rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🌟 Meet the Creators</Link>
      </section>

      <div className="flex justify-center py-6">
        <Link to="/nubbilab" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          backgroundColor: '#FF3B3B',
          border: '5px solid white',
          color: 'white',
          fontSize: '2rem',
          fontWeight: 'bold',
          textDecoration: 'none',
          boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
          transition: 'transform 0.3s',
        }}
          onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.1)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
        >
          🧪
        </Link>
      </div>

      <section className="py-8 text-center">
        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          <div className="bg-yellow-400 text-black rounded-xl px-8 py-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-2">This Week's Nubbis</h3>
            <p className="text-3xl font-extrabold text-red-600">{weeklyCreatureCount}</p>
          </div>
          <div className="bg-white text-black rounded-xl px-8 py-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-2">Live Nubbi Counter</h3>
            <p className="text-3xl font-extrabold text-purple-600">{creatureCount}</p>
          </div>
          <div className="bg-white text-black rounded-xl px-8 py-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-2">Total Visits</h3>
            <p className="text-3xl font-extrabold text-blue-600">{visitCount}</p>
          </div>
        </div>
      </section>

      <section className="flex flex-wrap justify-center gap-4 py-6">
        <Link to="/headsup" className="px-6 py-3 bg-green-400 text-black rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">⚔️ Heads Up</Link>
        <Link to="/elite-headsup" className="px-6 py-3 bg-green-600 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">👑 Elite Heads Up</Link>
        <Link to="/madness/top" className="px-6 py-3 bg-yellow-400 text-black rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🎮 Nubbi Madness</Link>
        <Link to="/madness/random" className="px-6 py-3 bg-orange-400 text-black rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🎲 Random Madness</Link>
        <Link to="/madness/multi" className="px-6 py-3 bg-red-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🌎 Madness by Universes</Link>
        <Link to="/nubbilab" className="px-6 py-3 bg-pink-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🧪 Nubbi Lab</Link>
        <Link to="/nubbigrid" className="px-6 py-3 bg-blue-400 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🧱 Nubbi Grid</Link>
        <Link to="/nubbi-hunt" className="px-6 py-3 bg-indigo-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🕵️ Nubbi Hunt</Link>
        <Link to="/rate" className="px-6 py-3 bg-purple-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🎯 Rate the Nubbis</Link>
        <Link to="/nubbi-wallpaper" className="px-6 py-3 bg-teal-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">📱 Nubbi Wallpapers</Link>
        <Link to="/nubbi-sm" className="px-6 py-3 bg-red-400 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">📈 Nubbi SM 💰</Link>
        <Link to="/peluches" className="px-6 py-3 bg-pink-400 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🧸 Nubbi Plushes</Link>
        <Link to="/squads" className="px-6 py-3 bg-indigo-500 text-white rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🚩 Nubbi Squads</Link>
        <Link to="/memorygame" className="px-6 py-3 bg-yellow-500 text-black rounded-xl font-bold text-lg shadow-lg hover:scale-110 transition">🧠 Nubbi Memory</Link>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-blue-500 to-purple-600 text-white text-center">
        <h3 className="text-3xl font-extrabold mb-12">🏆 Top 500 Most Voted Characters</h3>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 max-w-7xl mx-auto">
          {characters.map((char, index) => (
            <div key={char.id} className="cursor-pointer" onClick={() => setSelectedCharacter(char)}>
              <div className="relative">
                <span className="absolute top-2 left-2 text-white text-xl font-bold drop-shadow-lg">#{index + 1}</span>
                <img src={char.image ?? '/fallback.png'} alt={char.name ?? 'Nubbi'} className="rounded-xl w-full shadow-lg" />
              </div>
              <h4 className="mt-2 text-lg font-bold">{char.name}</h4>
              <p className="text-blue-300 font-bold text-xl">{char.vs_votes ?? 0} votes</p>
              <p className="text-sm mt-1"><span className="font-bold">Universe:</span> {char.universo ?? '—'}</p>
              <p className="text-sm"><span className="font-bold">Created by:</span> {char.creador_url ?? '—'}</p>
            </div>
          ))}
        </div>

        {selectedCharacter && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50" onClick={() => setSelectedCharacter(null)}>
            <img src={selectedCharacter.image} alt={selectedCharacter.name} className="max-w-3xl max-h-[80vh] rounded-xl shadow-2xl border-4 border-white" />
          </div>
        )}
      </section>

      <footer className="bg-black bg-opacity-50 text-center py-6 text-sm">
        📧 Contact: nubbiland@gmail.com
      </footer>
    </div>
  );
}
